export default __webpack_public_path__ + "static/media/PoweredByWax.e7311ca8.png";